import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

import { BaseButton, type BaseButtonProps } from "./BaseButton";

/**
 * `LinkButton` is a button that looks like a text link.
 * Unlike other children of BaseButton, it is *not* a polymorphic component:
 * it can *only* be rendered as a <button> element.
 * If you need a text link that is not a button, use the `Link` component from react-router-dom.
 */
export const LinkButton = forwardRef<HTMLButtonElement, BaseButtonProps<"button">>(
  function LinkButton({ className, ...rest }, ref) {
    return (
      <BaseButton
        as="button"
        className={twMerge(
          "max-w-fit cursor-pointer border-0 text-blue-shade-20 underline hover:text-blue active:text-blue-shade-40",
          className,
        )}
        ref={ref}
        {...rest}
      />
    );
  },
);
